import { deleteYleElements } from "./helpers/deleteYleElements";


deleteYleElements();
export const isSVTDuo = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return userAgent.indexOf("svtduo") > -1 || window.location.hash.includes("svtduo")
      }
const iframe = document.getElementById("artikkeli-frame")
console.log({duo: isSVTDuo()})

if(isSVTDuo()) {
	iframe.classList.add("duo-app")
	iframe.src = iframe.src + "?#svtduo"
}
const updateIframeWidth = () => {
	if (isSVTDuo()) {
		iframe.style.width = window.innerHeight + "px";
		return;
	}
	iframe.style.width = window.innerWidth + "px";
}

updateIframeWidth();
// Debounce
function debounce(func, time) {
	var time = time || 100; // 100 by default if no param
	var timer;
	return function (event) {
		if (timer) clearTimeout(timer);
		timer = setTimeout(func, time, event);
	};
}

function resizeContent() {
	updateIframeWidth()
}

window.addEventListener("resize", debounce(resizeContent, 150));